import { render, staticRenderFns } from "./UnidadAdministrativaView.vue?vue&type=template&id=10f76164&"
import script from "./UnidadAdministrativaView.vue?vue&type=script&lang=js&"
export * from "./UnidadAdministrativaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports